export const contactsInfo = {
  address: "Brasov,Romania",
  phone: "0757-217-748",
  phoneFormatted: "+40757217748",
  contactEmail: "contact@softindex.ro",
  facebookPage: "https://www.facebook.com/softindexlab",
  XPage: "https://x.com/home",
  instagramPage: "https://www.instagram.com/",
  linkedinPage: "https://www.linkedin.com/",
  whatsappPhoneNumber: `https://wa.me/40757217748?text=`,
  whatsappMessage:
    "Hello, I'm interested in your services and would like to discuss a potential project. Could we schedule a time to connect?",
};
